export default class DtoPARParameters {
    constructor(object) {
        this.base64data = object.base64data // String,
        this.fileName = object.fileName // String,
        this.params = object.params // ReadFileParams,
        this.columnsValues = object.columnsValues // LinksColumnPAR,
        this.askYear = object.askYear // Int,
        this.idSurvey = object.idSurvey // Int,
        this.loginAttribution = object.loginAttribution // Option[String],
        this.dateAttribution = object.dateAttribution // Option[DateTime],
        this.loginAutorisation = object.loginAutorisation // Option[String],
        this.dateAutorisation = object.dateAutorisation // Option[DateTime],
        this.supPreviousIntegration = object.supPreviousIntegration ?? false // Boolean,
    }
}
